/**
 * 浏览器环境判断
 */

// UA
const ua = window.navigator.userAgent || ''

// 常用browser信息
const isAndroid = /android/i.test(ua)
const isIOS = /iphone|ipad|ipod/i.test(ua)
const isIPX = /iphone|ipod/i.test(ua) && screen.height >= 812 && screen.width >= 375
const isWeChat = /micromessenger\/([\d.]+)/i.test(ua)
const isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua)
const isQQ = /qq\/([\d.]+)/i.test(ua)
const isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua)
const isQZone = /qzone\/.*_qz_([\d.]+)/i.test(ua)
// 安卓 chrome 浏览器，很多 app 都是在 chrome 的 ua 上进行扩展的
const isOriginalChrome = /chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(ua) && isAndroid
// chrome for ios 和 safari 的区别仅仅是将 Version/<VersionNum> 替换成了 CriOS/<ChromeRevision>
// iOS 上很多 app 都包含 safari 标识，但它们都是以自己的 app 标识开头，而不是 Mozilla
const isSafari = /safari\/([\d.]+)$/i.test(ua) && isIOS && ua.indexOf('Crios') < 0 && ua.indexOf('Mozilla') === 0

// 获取iOS大版本号
export function getIOSVersion() {
  const version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)
  return parseInt(version[1], 10)
}

export default {
  isAndroid,
  isIOS,
  isIPX,
  isWeChat,
  isWeibo,
  isQQ,
  isQQBrowser,
  isQZone,
  isOriginalChrome,
  isSafari,
}
